import { Filter } from './filter.js';
export class SharpenFilter extends Filter {
    _radius: number;
    _gain: number;
    minRadius: number;
    maxRadius: number;
    minGain: number;
    maxGain: number;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'sharpen', 'Netteté');
        this.reset();
    }

    get radius() {
        return this._radius;
    }

    set radius(value) {
        var self = this;
        self._radius = value;
        self._touch = true;
    }

    get gain() {
        return this._gain;
    }

    set gain(value) {
        var self = this;
        self._gain = value;
        self._touch = true;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._radius = 1;
        self.minRadius = 1;
        self.maxRadius = 10;

        self._gain = 100;
        self.minGain = 0;
        self.maxGain = 500;
    }

}
